import { Injectable } from "@angular/core";
import { Topics } from "@common/interfaces/topics";
import { SocketIoService } from "@ep-om/core/services/socket-io.service";
import { distinctUntilChanged, filter, repeatWhen, switchMap, takeUntil, tap } from "rxjs/operators";
import { AuthService } from "./auth.service";
import { combineLatest } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AuthUserService {
  constructor(private authService: AuthService, private socketIoService: SocketIoService) {
    this.socketIoService.uponConnection$.pipe(
      switchMap(() => this.authService.authQuery.userId$.pipe(
        tap(userId => console.log('[AUTH USER SERVICE] - userId ->', userId)),
        filter(userId => !!userId),
        distinctUntilChanged(),
        switchMap(user => this.socketIoService.listenResource(Topics.USERS, 'me')),
        tap(user => console.log('[AUTH USER SERVICE] - received user', user)),
        takeUntil(this.authService.authQuery.loggedIn$.pipe(filter(loggedIn => !loggedIn)),),
        repeatWhen(() => this.authService.authQuery.loggedIn$.pipe(filter(loggedIn => loggedIn))),
      )),
      this.socketIoService.stopOnDisconnectionPipe(),
      this.socketIoService.repeatOnConnectionPipe()
    ).subscribe(
      updates => {
        console.log('[AUTH USER SERVICE] Updating auth user with', updates.data[0]);
        this.authService.updateUser(updates.data[0]);
      }
    )
  }
}
